import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  SnVerkadaClipParams,
  SnVerkadaPresenceDataParams,
  SnVerkadaPresenceResponse,
  SnVerkadaStreamParams,
  SnVerkadaStreamResponse,
} from '../types';

@Injectable({ providedIn: 'root' })
export class SnVerkadaService {
  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _toastrService: ToastrService,
  ) {}

  public getPresenceData(
    params?: SnVerkadaPresenceDataParams,
  ): Observable<SnVerkadaPresenceResponse> {
    const httpParams = params
      ? new HttpParams({
          fromObject: {
            ...(params.pageSize !== undefined && { pageSize: params.pageSize.toString() }),
            ...(params.pageToken !== undefined && { pageToken: params.pageToken }),
          },
        })
      : undefined;
    return this._httpClient
      .get<SnVerkadaPresenceResponse>('/api/integrations/verkada-cloud/presence', {
        params: httpParams,
      })
      .pipe(
        tap({
          error: () =>
            this._toastrService.error(
              'Could not retrieve Verkada cameras. Please try again later.',
            ),
        }),
      );
  }

  public getStream(params: SnVerkadaStreamParams): Observable<SnVerkadaStreamResponse> {
    const httpParams = new HttpParams({
      fromObject: {
        cameraId: params.cameraId,
        ...(params.startTime !== undefined && { startTime: params.startTime.toString() }),
        ...(params.endTime !== undefined && { endTime: params.endTime.toString() }),
      },
    });
    return this._httpClient
      .get<SnVerkadaStreamResponse>('/api/integrations/verkada-cloud/stream', {
        params: httpParams,
      })
      .pipe(
        tap({
          error: () =>
            this._toastrService.error(
              'Could not retrieve Verkada stream URL. Please try again later',
            ),
        }),
      );
  }

  public generateClip(params: SnVerkadaClipParams): Observable<void> {
    const httpParams = new HttpParams({
      fromObject: {
        cameraId: params.cameraId,
        startTime: params.startTime.toString(),
        endTime: params.endTime.toString(),
      },
    });
    return this._httpClient
      .get<void>('/api/integrations/verkada-cloud/clip', { params: httpParams })
      .pipe(
        tap({
          error: () =>
            this._toastrService.error('Could not generate Verkada clip. Please try again later'),
        }),
      );
  }
}
